import React from "react";

/** Reusable clickable text for table cells (color #4287f5) */
export default function LinkCell({ children, onClick, title = "Open" }) {
  const base = { color: "#4287f5", cursor: "pointer" };
  const handle = (e) => {
    e.stopPropagation(); // avoid row onClick, if any
    onClick?.(e);
  };
  const handleKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handle(e);
    }
  };

  return (
    <span
      role="link"
      tabIndex={0}
      title={title}
      style={base}
      onClick={handle}
      onKeyDown={handleKey}
    >
      {children || "-"}
    </span>
  );
}
